import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-3" };
const _hoisted_2 = ["data-testid"];
const _hoisted_3 = { class: "flex items-center justify-between gap-2" };
const _hoisted_4 = { class: "text-[length:var(--size-l)] font-[var(--weight-bold)] text-(--text-text-black-default)" };
const _hoisted_5 = { class: "flex items-center gap-1" };
const _hoisted_6 = {
    key: 0,
    class: "text-[length:var(--size-m)] text-(--text-text-body)"
};
const _hoisted_7 = {
    key: 1,
    class: "text-[length:var(--size-m)] text-(--text-text-error)"
};
import { useI18n } from "vue-i18n";
import { Badge } from "@eudonet/opal";
import { APPLY_STATUSES, FAILURE_CODES } from "../../domain/request";
import { applyBadgeTheme, serviceLabel, useRequestTranslator, vocabularyKey } from "../requestLabels";
export default /*@__PURE__*/ _defineComponent({
    __name: 'RequestResultList',
    props: {
        targets: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const translator = useRequestTranslator();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.targets, (target) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: target.serviceCode,
                        class: "flex flex-col gap-1 rounded-lg border border-(--border-border-base-soft) px-4 py-3",
                        "data-testid": `request-result-${target.serviceCode}`
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(serviceLabel)(_unref(translator), target.serviceCode)), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_5, [
                                (target.appliedLate)
                                    ? (_openBlock(), _createBlock(_unref(Badge), {
                                        key: 0,
                                        theme: "yellow",
                                        label: _unref(t)('compliance.pseudonymise.result.lateAnswer'),
                                        "show-close-icon": false,
                                        "data-testid": `request-result-${target.serviceCode}-late`
                                    }, null, 8 /* PROPS */, ["label", "data-testid"]))
                                    : _createCommentVNode("v-if", true),
                                (target.hasDrift === true)
                                    ? (_openBlock(), _createBlock(_unref(Badge), {
                                        key: 1,
                                        theme: "violet",
                                        label: _unref(t)('compliance.pseudonymise.result.drift'),
                                        "show-close-icon": false,
                                        "data-testid": `request-result-${target.serviceCode}-drift`
                                    }, null, 8 /* PROPS */, ["label", "data-testid"]))
                                    : _createCommentVNode("v-if", true),
                                _createVNode(_unref(Badge), {
                                    theme: _unref(applyBadgeTheme)(target.applyStatus),
                                    label: _unref(t)(_unref(vocabularyKey)('compliance.request.applyStatus', target.applyStatus, _unref(APPLY_STATUSES))),
                                    "show-close-icon": false
                                }, null, 8 /* PROPS */, ["theme", "label"])
                            ])
                        ]),
                        (target.applied)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                _createTextVNode(_toDisplayString(_unref(t)("compliance.request.applied.fieldsModified", { count: target.applied.fieldsModified })) + " ", 1 /* TEXT */),
                                (target.applied.fieldsRetainedLegal > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString(_unref(t)("compliance.request.applied.fieldsRetainedLegal", { count: target.applied.fieldsRetainedLegal })), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ]))
                            : _createCommentVNode("v-if", true),
                        (target.applyStatus === 'Failed')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)(_unref(vocabularyKey)("compliance.request.failureCodes", target.applyFailureCode ?? "", _unref(FAILURE_CODES)))), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
